import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { usePermissions } from '../context/PermissionContext';
import { PageLoader } from '../components/Loader';

const ProtectedRoute = ({ children, requireAdmin = false, requiredPermission = null }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const { hasPermission, isLoading: permissionsLoading } = usePermissions();
  const location = useLocation();

  if (isLoading || permissionsLoading) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    // Redirect to login page with return url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check admin requirement (for backward compatibility)
  if (requireAdmin && user?.role !== 'admin') {
    // For non-admin users, check if they have any permissions
    // If they have at least one permission, allow access to dashboard
    // Individual pages will handle their own permission checks
    return <Navigate to="/login" replace />;
  }

  // Check specific permission if required
  if (requiredPermission) {
    const [resource, action] = requiredPermission.split(':');
    if (!hasPermission(resource, action)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;